export function setupConsentPersistence(consent) {
  const state = {};

  consent.persistence = {
    store(vendors, signal) {
      vendors.forEach(vendor => {
        state[vendor.name] =
          (signal === 'accepted' ? true :
           signal === 'denied' ? false :
           signal[vendor.name]);
      });
    },

    update(vendor, signal) {
      state[vendor.name] = signal;
    },

    read(vendor) {
      const flag = state[vendor.name];
      return flag === true ? 'accepted' :
             flag === false ? 'denied' : 'undecided';
    }
  };
}
